import React from "react";
import Table from "../../../../components/table/coreUiTable/Table";
import { useSelector } from "react-redux";

function formatData(colHeaders) {
  let slots = {
    scopedSlots: {},
    columnHeaderSlot: {}
  };
  colHeaders.forEach((colHeader) => {
    slots = {
      ...slots,
      scopedSlots: {
        ...slots.scopedSlots,
        [colHeader]: (item) => {
          return (
            <td>
              <div dangerouslySetInnerHTML={{ __html: item[colHeader] }} />
            </td>
          );
        }
      },
      columnHeaderSlot: {
        ...slots.columnHeaderSlot,
        [colHeader]: <div className="d-inline" dangerouslySetInnerHTML={{ __html: colHeader }} />
      }
    };
  });
  return slots;
}

function addTotal(data, total) {
  if (Array.isArray(total)) {
    data.push(total);
    return data;
  }
}

const BreakdownTable = () => {
  const {
    membershipsInfo: { colHeaders = [], data = [] },
    totalMembersCount
  } = useSelector((state) => state.membershipBreakdown);

  addTotal(data, totalMembersCount);
  const { scopedSlots, columnHeaderSlot } = formatData(colHeaders);

  return (
    <Table
      tableFilter={false}
      pagination={false}
      columnHeaderSlot={columnHeaderSlot}
      table={{ colHeaders, data }}
      scopedSlots={scopedSlots}
    />
  );
};

export default BreakdownTable;
